import { produce } from 'immer';

import { invitationActionTypes } from './invitation.types';

const initialState = {
    // Invitation details returned by the verify endpoint.
    // Expected shape: { workspace_name, inviter_name, invitee_email }
    data: null,

    isLoading: false,

    // null | { code, message }
    // code is one of: 'NOT_FOUND' | 'ALREADY_ACCEPTED' | 'EXPIRED' | 'REVOKED' | 'EMAIL_MISMATCH' | 'UNAUTHENTICATED' | 'UNKNOWN'
    error: null,

    // 'success' | 'error' | null
    acceptStatus: null,
};

const invitationReducer = (state = initialState, action) => {
    return produce(state, (draft) => {
        switch (action.type) {

            // VERIFY
            case invitationActionTypes.INVITATION_VERIFY_REQUEST: {
                draft.isLoading = true;
                draft.error = null;
                draft.data = null;
                break;
            }
            case invitationActionTypes.INVITATION_VERIFY_SUCCESS: {
                draft.data = action.payload;
                draft.isLoading = false;
                draft.error = null;
                break;
            }
            case invitationActionTypes.INVITATION_VERIFY_FAILURE: {
                draft.isLoading = false;
                draft.error = action.payload;
                break;
            }

            // ACCEPT
            case invitationActionTypes.INVITATION_ACCEPT_REQUEST: {
                draft.isLoading = true;
                draft.acceptStatus = null;
                break;
            }
            case invitationActionTypes.INVITATION_ACCEPT_SUCCESS: {
                draft.isLoading = false;
                draft.acceptStatus = 'success';
                break;
            }
            case invitationActionTypes.INVITATION_ACCEPT_FAILURE: {
                draft.isLoading = false;
                draft.acceptStatus = 'error';
                draft.error = action.payload;
                break;
            }

            // RESET
            case invitationActionTypes.INVITATION_RESET: {
                return initialState;
            }

            default:
                break;
        }
    });
};

export default invitationReducer;
